import checkCanTranslate from './checkCanTranslate';
import getOgmaSupportedLanguageTag from './getOgmaSupportedLanguageTag';
import getSupportedLanguages from '../services/getSupportedLanguages';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import store from '../store/store';

// This function initializes the translation store properties.
// It only updates the properties for the first call and
// any time user changes language (UserCulture in session settings)
// It returns 'true' when the store properties are updated.
export default async function initSupportedLanguages(): Promise<boolean> {
    const userCulture = getUserConfiguration().SessionSettings.UserCulture;
    if (userCulture !== store.localeOfSupportedLanguageMap) {
        const supportedLanguages = await getSupportedLanguages(userCulture);
        store.localeOfSupportedLanguageMap = userCulture;
        store.supportedLanguageMap = supportedLanguages;
        const userLocaleInOgma = getOgmaSupportedLanguageTag(userCulture);
        store.userLanguageName = supportedLanguages.get(userLocaleInOgma).LanguageName;
        store.isUserLocaleSupported = checkCanTranslate(userCulture);
        return true;
    }
    return false;
}
